import { partial } from '../../../util/translation/translation';

const p = partial('validateErrors');
const validateLogin = (values) => {
  const errors = {};
  if (!values.email) {
    errors.email = p('emailFieldCantBeEmpty');
  }

  if (!values.password) {
    errors.password = p('passwordFieldCantBeEmpty');
  }

  return errors;
};

export default validateLogin;
